module.exports = __webpack_public_path__ + "static/media/Organization_2.fcc48401.svg";